<div class="formfield">
    <label class="formfield__label">
        {{ 'COMPANY_DATA.INPUT.USER_HISTORY.LABEL_SELECT' | translate }}
    </label>
    <div class="formfield__inputContainer">
        <select
            class="select textInput--fullWidth"
            (ngModelChange)="selected.emit($event)"
            [(ngModel)]="selectedUserId"
            privacySensitive>
            <option
                *ngFor="let user of users"
                [value]="user.id"
                privacySensitive>
                {{ user | displayName | async }}
            </option>
        </select>
    </div>
</div>
